import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Point } from "ol/geom";
import { FeatureLike } from 'ol/Feature';
import { Style, Stroke, Icon } from 'ol/style';
import { StyleFunction } from "ol/style/Style";
import searchIcon from '../../img/search.svg';
import hoverSearchIcon from '../../img/hoverSearch.svg';
import {parseSearchResults2Features} from '../search';
import { ScoreableSearchResult } from "../interfaces/interfaces";


const getSearchStyle = (src: string, scale = 1) =>
  new Style({
    image: new Icon({
      src: src,
      scale: scale,
      imgSize: [24, 24],
      anchor: [0.5, 1],
    }),
    stroke: new Stroke({
      color: [0, 255, 255],
      width: 3,
    }),
  });

const simpleSearchStyle = getSearchStyle(searchIcon, 1.25);

const focusedSearchStyle = getSearchStyle(hoverSearchIcon, 1.5);

export const searchStyle = (id?: string | number | undefined): StyleFunction => (feature: FeatureLike, resolution: number) => {
  let fid = feature.getId();
  if (fid && fid === id) {
    return focusedSearchStyle;
  } else {
    return simpleSearchStyle;
  }
};


// The search layer visualizes the search results.
export const searchLayer = new VectorLayer({
  source: new VectorSource<Point>({}),
  visible: true,
  style: searchStyle() // no hover => no id initial provided
});

/**
 * Updates the search layer with the search results.
 * @param searchResults The search results to update with.
 */
export const updateSearchLayer = (searchResults: ScoreableSearchResult[]|undefined) => {
  let searchSource = searchLayer.getSource();
  if (searchSource) {
    searchSource.clear();
    if(searchResults) {
      searchSource.addFeatures(parseSearchResults2Features(searchResults));
    }
  }
}
